<template>
  <m4-card :class="classes">
    <m4-icon v-if="withBgImg" icon="paper-stack" class="wizard_bg"></m4-icon>
    <m4-heading level="2">
      {{ title }}
    </m4-heading>
    <div class="wizard__subtitle" v-html="subtitle"></div>
    <div v-if="error" class="wizard__error-icon">
      <m4-icon :icon="icon"></m4-icon>
    </div>
    <div v-if="btnLink" class="wizard__button">
      <m4-button tag="a" :href="btnLink" :variant="btnVariant" size="xl">{{ btnTitle }}</m4-button>
    </div>
    <div v-if="hasButtonSlot" class="wizard__button">
      <slot name="button"></slot>
    </div>
  </m4-card>
</template>

<script>
export default {
  name: "M4Wizard",
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    withBgImg: {
      type: Boolean,
      default() {
        return true;
      }
    },
    error: {
      type: Boolean,
      default() {
        return false;
      }
    },
    icon: {
      type: String,
      default() {
        return "exclamation-alt";
      }
    },
    iconVariant: {
      type: String,
      default() {
        return "danger";
      }
    },
    btnVariant: {
      type: String,
      default() {
        return "primary";
      }
    },
    btnTitle: {
      type: String,
      default() {
        return "Start registration";
      }
    },
    btnLink: {
      type: String
    }
  },
  computed: {
    classes() {
      let classes = ["wizard"];

      classes.push("wizard--icon-variant-" + this.iconVariant);

      return classes;
    },
    hasButtonSlot() {
      return typeof this.$slots.button === "function";
    }
  }
};
</script>
